<template>
  <div class="container p-d-flex p-flex-column p-ai-center p-jc-center">
    <div class="p-m-2 p-as-center">
      <h2>
        {{ notAuthorizedMessage[message] }}
      </h2>
    </div>
    <div class="p-m-2 p-as-center">
      <a
        v-if="message === MESSAGE_TYPES.DEFAULT"
        :href="outdoorvisionWebsite"
      >
        <Button
          :label="notAuthorizedButton.default"
          icon="pi pi-arrow-circle-right"
          icon-pos="right"
        />
      </a>
      <Button
        v-else
        :label="notAuthorizedButton.cgu"
        icon="pi pi-arrow-circle-right"
        icon-pos="right"
        @click="goToLogin"
      />
    </div>
  </div>
</template>

<script>
import Button from 'primevue/button';
import { notAuthorizedMessage, notAuthorizedButton } from '@/utils/settings';

const MESSAGE_TYPES = {
  DEFAULT: 'default',
  CGU: 'cgu',
};

export default {
  name: 'NotAuthorized',
  components: { Button },
  props: {
    message: {
      type: String,
      default: 'default',
    },
  },
  data () {
    return {
      notAuthorizedMessage,
      notAuthorizedButton,
      MESSAGE_TYPES,
      outdoorvisionWebsite: process.env.VUE_APP_FRONT_PUBLIC_URL,
    };
  },
  methods: {
    goToLogin () {
      this.$keycloak.authenticated
        ? this.$keycloak.logoutFn()
        : this.$keycloak.loginFn();
    },
  },
};

</script>

<style scoped>
.container {
  margin-top: 10%;
  margin-bottom: 20%;
}
</style>
